<template>
  <button type="button" class="btn-prev" :disabled="internalDisabled" :aria-label="prevText || t('z.pagination.prev')"
    :aria-disabled="internalDisabled" @click="$emit('click', $event)">
    <span v-if="prevText">{{ prevText }}</span>
    <z-icon v-else>
      <component :is="prevIcon" />
    </z-icon>
  </button>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useLocale } from '@zoryn/hooks'
import { ZIcon } from '@zoryn/components/icon'
import { paginationPrevEmits, paginationPrevProps } from './prev'

defineOptions({
  name: 'ZPaginationPrev',
})

const props = defineProps(paginationPrevProps)
defineEmits(paginationPrevEmits)

const { t } = useLocale()

const internalDisabled = computed(
  () => props.disabled || props.currentPage <= 1
)
</script>
